var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-view-container"},[_c('iframe',{ref:"webView",staticClass:"iframe-container",attrs:{"src":_vm.$route.params.url,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }